export const hasAnyActiveFilter = ({
  allSelectedOptions,
  processedFilter,
  searchInput
}) => {
  const hasReactFilters = Array.from(allSelectedOptions.values())
    .some(v => v.length > 0)

  return (
    hasReactFilters ||
    Boolean(processedFilter) ||
    Boolean(searchInput)
  )
}

export const hasAvailableFilters = (filters = []) =>
  filters.some(f => Array.isArray(f.value) && f.value.length > 0)
